import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
	documentWorkflowControllerAddInvestorsMutation,
	documentWorkflowControllerGetAddInvestorEligibilityOptions,
	documentWorkflowControllerGetAddInvestorEligibilityQueryKey,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { getDocumentWorkflowEventsQueryKey } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useDocumentWorkflowEvents';
import type { AddInvestorsPanelState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useAddInvestorsToDocument.types';

export const useAddInvestorsToDocument = (params: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}): AddInvestorsPanelState => {
	const queryClient = useQueryClient();

	const eligibility = useQuery(
		documentWorkflowControllerGetAddInvestorEligibilityOptions({ path: params })
	);

	const addInvestors = useMutation({
		...documentWorkflowControllerAddInvestorsMutation(),
		onSuccess: async () => {
			// The eligibility count and the activity log both move together with the addition.
			await Promise.all([
				queryClient.invalidateQueries({
					queryKey: documentWorkflowControllerGetAddInvestorEligibilityQueryKey({
						path: params,
					}),
				}),
				queryClient.invalidateQueries({
					queryKey: getDocumentWorkflowEventsQueryKey(params),
				}),
			]);
		},
	});

	return { eligibility, addInvestors };
};
